export interface WhatsappTemplateMediaPostModel {
  message: string;
  status: number;
  code: string;
  code_app: string;
  data?: { name: string, url: string }
}

// export interface UsersGetModel {
//   message: string;
//   status: number;
//   code: string;
//   code_app: string;
//   data: UsersDataModel
// }

// export interface UsersDataModel {
//   items: UsersItems[];
// }

// export interface UsersItems {
//   id: number,
//   identification_type: null,
//   identification_number: number,
//   email: string,
//   first_name: string,
//   last_name: string,
//   profile_image_url: null,
//   phone_area_code: number,
//   phone_number: number,
//   status_id: number,
//   status_name: string,
//   roles_id: number,
//   role_name: string,
//   devices_id: string,
//   created_at: string,
//   updated_at: string
// }

export interface WhatsappTemplatesCreatePostModel {
  message: string;
  status: number;
  code: string;
  code_app: string;
  data: {
    requested_category?: string;
    category?: string;
    category_changed?: boolean;
    status?: string;
    meta_error?: string | null;
    error?: any;
  } | null
}

export interface WhatsappTemplatesCreateModel {
  whatsapp_account_id?: number
  template: WhatsappTemplatesModel
}


export interface WhatsappTemplatesGetModel {
  message: string;
  status: number;
  code: string;
  code_app: string;
  data: { items: WhatsappTemplatesItemsModel[] }
}



export interface WhatsappTemplatesItemsModel {
  // id: number,
  // name: string,
  // language: number,
  // category: number,
  // allow_category_change: boolean,
  // status_id: number,
  // status_name: string,
  // components: {
  //   header?: {
  //     format: string,
  //     content: string,
  //     example: string
  //   },
  //   body?: {
  //     content: string,
  //     examples: string[]
  //   },
  //   footer?: {
  //     content: string
  //   },
  //   buttons?: WhatsappTemplatesButtonsModel[]
  // }


  id: number;
  whatsapp_account_id: number;
  name: string;
  allow_category_change: boolean;
  category_name: string;
  language_code: string;
  header_content: string;
  header_example: string;
  header_format: string,
  body_id: number;
  body_content: string;
  body_examples: [];
  status_id: number;
  status_name: string;
  footer_content: string;
  buttons: WhatsappTemplatesButtonsModel[];
  // button_type: string;
  // button_text: string;
  // button_content: string;
  // button_example: string;
}




// export interface WhatsappTemplatesItemsModel {
//   id: number,
//   name: string,
//   language: number,
//   category: number,
//   allow_category_change: boolean,
//   status_id: number,
//   status_name: string,
//   components: {
//     header?: {
//       format: string,
//       content: string,
//       example: string
//     },
//     body?: {
//       content: string,
//       examples: string[]
//     },
//     footer?: {
//       content: string
//     },
//     buttons?: WhatsappTemplatesButtonsModel[]
//   }
// }



export interface WhatsappTemplatesModel {
  name: string,
  language: number,
  category: number,
  allow_category_change: boolean,
  // Solo para categoría Autenticación (OTP)
  authentication?: WhatsappTemplateAuthenticationModel,
  components: {
    header?: {
      format: string,
      content: string,
      example: string
    },
    body?: {
      content: string,
      examples: string[]
    },
    footer?: {
      content: string
    },
    buttons?: WhatsappTemplatesButtonsModel[]
  }
}

export interface WhatsappTemplatesButtonsModel {
  action_type: number,
  type: number,
  text: string,
  content: string,
  example?: string,
  url_type?: number
}


// interface Buttons {
//     type: number,
//     text: string,
//     content: string,
//     example?: string,
//     url_type?: string
// }

export interface WhatsappTemplateAuthenticationModel {
  add_security_recommendation: boolean,
  code_expiration_minutes: number | null,
  button_text: string
}

// Ids locales de whatsapp_templates_categories
export const TEMPLATE_CATEGORY = {
  MARKETING: 1,
  UTILITY: 2,
  AUTHENTICATION: 3,
} as const;
